/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, YoutubeIntegrationGetStationStatsSelfViewersPathParams, YoutubeIntegrationGetStationStatsSelfViewersQueryParams, YoutubeIntegrationGetStationStatsSelfViewers401, YoutubeIntegrationGetStationStatsSelfViewers403 } from "../models/YoutubeIntegrationGetStationStatsSelfViewers";

export function getYoutubeIntegrationGetStationStatsSelfViewersUrl(station: YoutubeIntegrationGetStationStatsSelfViewersPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube-integration/v1/stats/viewers/${station}/self` as const }
  return res
}

/**
 * @description Uses the station `youtubeChannelId`. Responds with 400 when it is not set, and 404 when the channel is not in the live-viewers catalog.
 * @summary Viewer time series for the station YouTube channel
 * {@link /youtube-integration/v1/stats/viewers/:station/self}
 */
export async function youtubeIntegrationGetStationStatsSelfViewers(station: YoutubeIntegrationGetStationStatsSelfViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsSelfViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetStationStatsSelfViewers401 | YoutubeIntegrationGetStationStatsSelfViewers403>, unknown>({ method : "GET", url : getYoutubeIntegrationGetStationStatsSelfViewersUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}